import DataCenter from "../../common/dataCenter/DataCenter"

const DataCenterPage = () => {
   return (
      <DataCenter />
   )
}

export default DataCenterPage
